export function applyDashboardSavedExperimentFollowUp(newExperiment, applyTo = {}, deps) {
  const {
    instrument,
    setComparisonInstrument,
    setIsOptimizePanelExpanded,
    setOptimizationExperimentSource,
    setOptimizationSourceKind,
  } = deps

  if (applyTo.addAsComparison) {
    setComparisonInstrument({
      type: instrument.type,
      id: instrument.id,
      experimentId: newExperiment.id,
    })
  }
  if (applyTo.addAsOptimizationInput) {
    setIsOptimizePanelExpanded(true)
    setOptimizationSourceKind("experiment")
    setOptimizationExperimentSource({
      experimentId: newExperiment.id,
      name: newExperiment.name,
    })
  }
}
